import { omit } from 'lodash'

import {
  CASE_MANAGER,
  CLINICIAN,
  COMPANY_DIVISION,
  DIVISION,
  GROUP,
  NO_GROUP_DROPDOWN_VALUE,
  PROVIDER,
  UUID
} from 'src/constants'

import { mapListForDropdownV5 } from './Array'

const ALL_ITEM = {
  key: 'all',
  title: 'All',
  label: 'All',
  value: '',
  children: []
}

export const convertDataFields = (
  collection = [],
  childrenKey = 'children',
  fields = [],
  showOnlyActive = false
) =>
  Array.isArray(collection)
    ? [...collection]
        .filter(({ isActive }) => (showOnlyActive ? isActive : true))
        .map((node = {}, key = 0) => {
          const updatedNode = mapListForDropdownV5(node, key)
          updatedNode.searchField = node?.searchField || null

          if ('disabled' in node) {
            updatedNode.disabled = node.disabled
          }

          fields.forEach((field) => {
            if (field in node) {
              updatedNode[field] = node[field]
            }
          })

          if (childrenKey in node && node[childrenKey].length) {
            updatedNode[childrenKey] = convertDataFields(
              node[childrenKey],
              childrenKey,
              fields,
              showOnlyActive
            )
          }
          return updatedNode
        })
    : collection

export const addAllValue = ({
  allItem = ALL_ITEM,
  convertList = true,
  fields = [],
  list = []
}) => [
  {
    ...allItem,
    children: convertList ? convertDataFields(list, 'children', fields) : list
  }
]

const getFinalFilter = ({
  accumulator = {},
  companyHierarchyValue = '',
  deleteFields = [],
  renamingScheme = {}
}) => {
  const updAccumulator = {}

  Object.keys(accumulator).forEach((fieldName = '') => {
    updAccumulator[fieldName] = accumulator[fieldName].filter(
      (item = '') => item
    )

    if (!accumulator[fieldName].length) {
      updAccumulator[fieldName] =
        fieldName === COMPANY_DIVISION
          ? [companyHierarchyValue]
          : [ALL_ITEM.value]
    }
  })

  if (accumulator[GROUP]?.length !== accumulator[CASE_MANAGER]?.length) {
    updAccumulator[GROUP] = [
      ...accumulator[GROUP],
      NO_GROUP_DROPDOWN_VALUE.value
    ]
  }

  Object.keys(renamingScheme).forEach((nameFrom = '') => {
    const nameTo = renamingScheme[nameFrom]

    updAccumulator[nameTo] = updAccumulator[nameFrom]

    delete updAccumulator[nameFrom]
  })

  return omit(updAccumulator, deleteFields)
}

export const getCareTeamFilters = ({
  careTeams = [],
  companyHierarchyValue = '',
  deleteFields = [],
  renamingScheme = {},
  selectedCareTeams = []
}) => {
  let filter = careTeams
    .filter(({ value }) => selectedCareTeams.includes(value))
    .reduce(
      (accumulator = {}, currentValue = {}) => ({
        [CASE_MANAGER]: [
          ...accumulator[CASE_MANAGER],
          currentValue?.[CASE_MANAGER]?.[UUID] || null
        ],
        [COMPANY_DIVISION]: [
          ...accumulator[COMPANY_DIVISION],
          currentValue?.[DIVISION]?.[UUID] || null
        ],
        [CLINICIAN]: [
          ...accumulator[CLINICIAN],
          currentValue?.[CLINICIAN]?.[UUID] || null
        ],
        [GROUP]: [...accumulator[GROUP], currentValue?.[GROUP]?.[UUID] || null],
        [PROVIDER]: [
          ...accumulator[PROVIDER],
          currentValue?.[PROVIDER]?.[UUID] || null
        ]
      }),
      {
        [CASE_MANAGER]: [],
        [CLINICIAN]: [],
        [COMPANY_DIVISION]: [],
        [GROUP]: [],
        [PROVIDER]: []
      }
    )
  filter = getFinalFilter({
    accumulator: filter,
    companyHierarchyValue,
    deleteFields,
    renamingScheme
  })

  return filter
}
